<template>
  <button :class="{ [props.display ?? 'primary']: true }" :type="props.type" :disabled="props.disabled">
    <slot>
      {{ props.type === 'submit' ? 'Submit' : props.type === 'reset' ? 'Reset' : '' }}
    </slot>
  </button>
</template>

<script setup lang="ts">
const props = defineProps<{
  display?: "primary"|"secondary"|"danger"
  type?: "submit"|"reset"
  disabled?: boolean
}>()
</script>

<style lang="css" scoped>
button {
  padding: 5px 10px;
  /* Required if someone wants to add an icon or something inside the button */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  cursor: pointer;
  font-size: inherit;

  &:disabled {
    background-color: var(--color-background-mute);
    cursor: not-allowed;
  }

  &.primary:not(:disabled) {
    background-color: var(--color-accent);
    transition: 0.5s background-color ease;
    color: white;
    
    &:hover {
      background-color: var(--color-accent-dark);
    }
  }

  &.secondary:not(:disabled) {
    background-color: var(--color-background-mute);
    color: var(--color-text-mute);
  }

  &.danger:not(:disabled) {
    background-color: var(--color-background-danger);
    color: var(--color-danger);
  }
}
</style>
